import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
      <hr></hr>
      <p>
        © 2026 bzread.in &bull; <a href="mailto:feedback@bzread.in">feedback@bzread.in</a>
      </p>
    </div>
  );
};

export default Footer;
